import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard }     from './services/authguard.service';
import { AntiAuthGuard }     from './services/anti-authguard.service';
import { LoginComponent }   from './login/login.component';
import { UsersComponent } from './users/users.component';
import { ReportsComponent } from './reports/reports.component';


export const ROUTES: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent, canActivate: [AntiAuthGuard] },
  { path: 'reports', component: ReportsComponent, canActivate: [AuthGuard] }

];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts